import { first, map, Observable, tap } from 'rxjs';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthFacade } from '../+state/auth.facade';

@Injectable({
  providedIn: 'root',
})
export class ModuloGuard implements CanActivate {
  constructor(private authFacade: AuthFacade, private router: Router) {}

  canActivate(activeRoute: ActivatedRouteSnapshot): Observable<boolean> {
    return this.authFacade.modulo$.pipe(
      tap((modulo) => {
        if (
          (!modulo && !activeRoute.data['modulo']) ||
          modulo?.codice !== activeRoute.data['modulo']
        ) {
          this.router.navigateByUrl('/', { replaceUrl: true });
        }
      }),
      map((modulo) => !!modulo),
      first()
    );
  }
}
